module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"serviceMetadataChips.viewInAzure":"View in Azure"}}')
  delete Component.options._Ctor
}
